import * as _ from "lodash"

type TQueryParams = {[key:string]:string|boolean};

export type { TQueryParams }

export default class Url {
    scheme : string = "";
    host : string = "";
    port : number = 0;
    path : string = "";
    pathname : string = "";
    filename : string = "";
    query : TQueryParams = {};
    fragment : string = "";
    
    constructor(url:Url|string) {
        if (url instanceof Url){
            this.scheme = url.scheme;
            this.host = url.host;
            this.port = url.port;
            this.path = url.path;
            this.pathname = url.pathname;
            this.filename = url.filename;
            this.query = _.clone(url.query);
            this.fragment = url.fragment;
        }
        else this.parse(url as string);
    }
    get clone(){ return new Url(this) }
    parse(url:string) {
        const match = url.match(/^([^:]+):\/\/\/?([^\/:\?#]+)(?::(\d+))?(.*)$/);
        if (match) {
            this.scheme = match[1];
            this.host = match[2];
            this.port = match[3]?parseInt(match[3]):(this.scheme=="https" ? 443 : 80);
            url = match[4]||"";
            if (url[0]!="/") url = "/" + url
        }
        else {
            throw "Invalid URL " + url
        }

        const path = url.match(/^(\/[^\?#]*)?(?:\?([^\#]*))?(?:\#(.*))?$/);
        if (path) {
            this.path = path[1];
            this.fragment = path[3];
            this.query = Url.parseQuery(path[2]);
            
            const filename = this.path.match(/^.*\/([^\/]*)$/);
            if (filename) {
                this.filename = filename[1];
                this.pathname = this.path.substring(0, this.path.length - this.filename.length)
            }
            else this.pathname = this.path;
        }
        else {
            this.path = this.pathname = "/";
            this.fragment = "";
            this.filename = "";
            this.query = {};
        }
        return this;
    }
    static decodeUrl(val:string) : string {
        let match;
        while( (match=val.match(/%([a-fA-F0-9]{2,2})/)) ) {
            val = val.replace(match[0], String.fromCharCode(parseInt(match[1],16)));
        }
        return(val);
    }
    static parseQuery(qs:string) : TQueryParams {
        const ret :TQueryParams = {};
        if (qs) {
            const tokens = qs.split("&");
            for(let i=0,size=tokens.length; i<size; i++) {
                const eq = tokens[i].indexOf("=");
                if (eq>0) ret[Url.decodeUrl(tokens[i].substring(0, eq))] = Url.decodeUrl(tokens[i].substring(eq+1));
                else if (tokens[i]) ret[tokens[i]] = true;
            }
        }
        return(ret);
    }
    static queryToString(query:TQueryParams) : string{
        let ret = "";
        for(let key in query){
            if (ret) ret += "&";
            const val = query[key];
            if (val===true) ret += encodeURIComponent(key);
            else ret += encodeURIComponent(key) + "=" + encodeURIComponent(val)
        }
        return(ret);
    }
    toString() : string {
        let ret = this.scheme + "://" + this.host, query = Url.queryToString(this.query);
        if (this.port!=80 && this.port!=443) ret += ":" + this.port;
        if (this.path) ret += this.path;
        if (query) ret += "?" + query;
        if (this.fragment) ret += "#" + this.fragment;
        return(ret);
    }
}